import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'shared/components/table/DataTable';
import { searchCoupons } from 'features/coupon/api/coupons';
import { modelMap } from 'shared/utils';
import { FilterRedirect } from 'shared/hoc/withFilters';
import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import CouponApplicableBy from './CouponApplicableBy';
import { FILTER_DISPLAY_TYPE } from '../../shared/constants';

const columns = [
  {
    name: 'Coupon',
    orderBy: 'coupon',
    formatter: (row) => <Link to={`/coupon/view/${row.couponId}`}>{row.couponId}</Link>,
  },
  {
    name: 'Discount',
    jsonKey: 'discount',
    orderBy: 'discount',
  },
  {
    name: 'Valid For',
    formatter: (row) => {
      const { ruleType } = row;
      if (ruleType === 'tenant') {
        return (
          <CouponApplicableBy
            ruleType="tenant"
            tenantId={row.tenantId}
            tenantName={row.tenantName}
          />
        );
      }
      if (ruleType === 'global') return <CouponApplicableBy ruleType="global" />;

      const rules = [];
      const names = row[modelMap[ruleType].nameKey].split(',');
      const ids = row[modelMap[ruleType].idKey].split(',');
      ids.forEach((id, i) => {
        rules.push({ id, name: names[i] });
      });

      return <CouponApplicableBy ruleType={ruleType} rules={rules} />;
    },
  },
  {
    name: 'Fully Redeemed',
    formatter: (row) => (row.fullyRedeemed === true ? 'Yes' : 'No'),
  },
  {
    name: 'Description',
    jsonKey: 'description',
  },
  {
    name: 'Created By',
    jsonKey: 'createdBy',
    orderBy: 'created_by',
  },
  {
    name: 'Created At',
    orderBy: 'created_at',
    formatter: (row) => new Date(row.createdAt).toLocaleDateString(),
  },
];

const validForOptions = ['tenant', 'property', 'complex', 'manager']
  .map((key) => ({ label: modelMap[key].plural, value: key }))
  .concat([{ label: 'Everyone', value: 'global' }]);

const usageOptions = [
  {
    label: 'Fully Redeemed',
    value: 'true',
  },
  {
    label: 'Has More Redemptions',
    value: 'false',
  },
];

const filters = [
  {
    label: 'Fully Redeemed',
    param: 'fully_redeemed',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: usageOptions,
    }),
  },
  {
    label: 'Valid For',
    param: 'rule_type',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: validForOptions,
    }),
  },
];

/**
 * @param {Object} props
 * @param {string} props.filterKey
 * @param {string} props.savedFilters
 * @param {string} props.path
 */
export default function CouponSearch({ filterKey, savedFilters, path }) {
  if (!FilterRedirect(path, savedFilters)) {
    return (
      <DataTable
        columns={columns}
        filters={filters}
        filterKey={filterKey}
        searchRequest={searchCoupons}
        rowId="couponId"
        tableName="Coupons"
        className="table-height-large"
      />
    );
  }
}
